export default __webpack_public_path__ + "static/media/Maintenance Connection.c90bef35.png";